/**
 * Wat de import van het monsterplan (Vooronderzoek → Importeren) leest, en voorbeeldbestanden
 * om te laten zien wat we verwachten. De voorbeelden gaan in de test door dezelfde lezer
 * (tests/monsterplan-voorbeeld.test.mjs): een voorbeeld dat niet inleest is erger dan geen.
 */

/**
 * Wat je kunt importeren, zoals de popup het toont: per soort een label, uitleg, de extensies en
 * wat het in GeoVoice oplevert.
 */
export const IMPORT_SOORTEN = [
  {
    id: 'meetstaat', label: 'TABEL', kleur: 'groen', titel: 'Meetstaat',
    uitleg: 'Een tabel met per regel één boorpunt.',
    ext: ['.csv', '.txt', '.xlsx'], wordt: 'Geplande boringen', kolommen: true,
  },
  {
    id: 'gis', label: 'GIS', kleur: 'blauw', titel: 'GIS-bestand',
    uitleg: 'Vlakken worden deellocaties, punten worden geplande boringen.',
    ext: ['.geojson', '.kml', '.kmz', '.zip (shapefile)', '.dxf'], wordt: 'Deellocaties + boringen',
  },
  {
    id: 'tekening', label: 'PDF', kleur: 'oranje', titel: 'Situatietekening',
    uitleg: 'Zonder coördinaten. Je lijnt hem uit met paspunten en tekent er daarna op.',
    ext: ['.pdf', '.png', '.jpg', '.webp', '.tif'], wordt: 'Achtergrond',
  },
];

/** De kolommen van een meetstaat: naam, uitleg en een voorbeeldwaarde. */
export const MEETSTAAT_KOLOMMEN = [
  { kolom: 'naam', uitleg: 'Puntnaam', voorbeeld: 'B01, PB01' },
  { kolom: 'soort', uitleg: 'Boring, peilbuis, proefgat of sleuf', voorbeeld: 'peilbuis' },
  { kolom: 'x / y', uitleg: 'RD, UTM of graden', voorbeeld: '155000 · 463000' },
  { kolom: 'diepte', uitleg: 'In m –mv of cm', voorbeeld: '2,0 · 200' },
  { kolom: 'opmerking', uitleg: 'Optioneel', voorbeeld: '—' },
];

/** Onder de kolommentabel. */
export const MEETSTAAT_KOLOMMEN_NOOT = 'Andere kolomnamen zoals boornr, RD-X of einddiepte herkennen we ook.';

// Utrecht, rond het Janskerkhof: een herkenbare plek, ver van echte projecten.
const MEETSTAAT_CSV = [
  'naam;soort;x;y;diepte (m -mv);opmerking',
  'B01;boring;136520;456010;2,0;',
  'B02;boring;136560;456030;2,0;',
  'B03;boring;136540;455980;0,5;bovengrond',
  'B04;boring;136580;455995;0,5;bovengrond',
  'PB01;peilbuis;136550;456005;3,0;filter 2,0-3,0 m',
].join('\r\n') + '\r\n';

const GEOJSON = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: { name: 'DL01', strategy: 'ONV-NL' },
      geometry: {
        type: 'Polygon',
        coordinates: [[[5.12150, 52.09310], [5.12260, 52.09310], [5.12260, 52.09250], [5.12150, 52.09250], [5.12150, 52.09310]]],
      },
    },
    { type: 'Feature', properties: { name: 'B01', kind: 'boring', depth_cm: 200 }, geometry: { type: 'Point', coordinates: [5.12180, 52.09295] } },
    { type: 'Feature', properties: { name: 'B02', kind: 'boring', depth_cm: 200 }, geometry: { type: 'Point', coordinates: [5.12230, 52.09295] } },
    { type: 'Feature', properties: { name: 'B03', kind: 'boring', depth_cm: 50 }, geometry: { type: 'Point', coordinates: [5.12180, 52.09265] } },
    { type: 'Feature', properties: { name: 'PB01', kind: 'peilbuis', depth_cm: 300 }, geometry: { type: 'Point', coordinates: [5.12230, 52.09265] } },
  ],
};

/** De voorbeeldbestanden in de popup. `inhoud` is tekst; de BOM zorgt dat Excel de é goed leest. */
export const VOORBEELDEN = [
  {
    id: 'meetstaat', label: 'meetstaat.csv', bestand: 'voorbeeld-meetstaat.csv',
    mime: 'text/csv;charset=utf-8', inhoud: '﻿' + MEETSTAAT_CSV,
  },
  {
    id: 'geojson', label: 'monsterplan.geojson', bestand: 'voorbeeld-monsterplan.geojson',
    mime: 'application/geo+json', inhoud: JSON.stringify(GEOJSON, null, 2),
  },
];

/** Een voorbeeld downloaden (in de browser). */
export function downloadVoorbeeld(v) {
  const url = URL.createObjectURL(new Blob([v.inhoud], { type: v.mime }));
  const a = Object.assign(document.createElement('a'), { href: url, download: v.bestand });
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
